import { render, staticRenderFns } from "./suketTidakMampu.vue?vue&type=template&id=e793835e&"
import script from "./suketTidakMampu.vue?vue&type=script&lang=js&"
export * from "./suketTidakMampu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions,QMarkupTable,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QCardActions,QMarkupTable}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
